import styled from 'styled-components';

export default styled.div`
  margin-top: 3rem;
  display: grid;
  font-size: 0.9rem;
`;
